module.exports = isPromise;

function isPromise(obj) {
  return obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/fluxible/~/is-promise/index.js
 ** module id = 215
 ** module chunks = 0
 **/